import { Component, Input, SimpleChanges, OnInit, inject, DestroyRef } from '@angular/core';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { IndianNumberFormatPipe } from '../../../../../pipes/format-number/format-number.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-engagement-cards',
    templateUrl: './engagement-cards.component.html',
    styleUrl: './engagement-cards.component.scss',
    imports: [NgFor, NgIf, NgClass, IndianNumberFormatPipe]
})
export class EngagementCardsComponent implements OnInit {
  @Input() values: any;
  @Input() isDeviationEnabled = false;
  comparisonLabel = '';
  isDataAvailable: boolean = false;
  private destroyRef = inject(DestroyRef);
  aggregateTrendsDetails: any[] = [{
    "display_name": "Records Received",
    "field_value": 0,
    "color": "rgba(148, 103, 189, 0.5)"
  }, {
    "display_name": "Records Delivered",
    "field_value": 0,
    "color": "rgba(255, 127, 15, 0.5)"
  }, {
    "display_name": "Responses Received",
    "field_value": 0,
    "color": "rgba(45, 160, 43, 0.5)"
  }, {
    "display_name": "Response Rate (%)",
    "field_value": 0,
    "color": "rgba(227, 119, 194, 0.5)"
  }
  ];

  constructor(
    private engagementService: EngagementService,
    private helpersService: HelpersService) {

  }

  ngOnInit(): void {
    this.helpersService.datePicker.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((datePicker: any) => {
      if (datePicker) {
        this.comparisonLabel = this.helpersService.getDeviationComparisonLabel(datePicker);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['values'] && changes['values'].currentValue) || changes['isDeviationEnabled']) {
      let data = changes['values']?.currentValue || this.values;
      if (data) {
        this.prepareDataForRequestJourney(data);
      }
    }
  }

  prepareDataForRequestJourney(data: any) {

    this.aggregateTrendsDetails[0].field_value = 0;
    this.aggregateTrendsDetails[1].field_value = 0;
    this.aggregateTrendsDetails[2].field_value = 0;
    this.aggregateTrendsDetails[3].field_value = 0;

    if (data && data.current && (data.current.number_of_requests_received || data.current.number_of_request_generated_rated)) {
      let detailedSummary: {
        responded: number,
        delivered: number,
        number_of_requests: number
        responseRate: number,
      } = {
        responded: 0,
        delivered: 0,
        number_of_requests: 0,
        responseRate: 0,
      };

      detailedSummary.number_of_requests = this.engagementService.getRequestRecieved(data.current);
      detailedSummary.responded = (data.current.number_of_request_generated_rated || 0);
      detailedSummary.delivered = (data.current.number_of_unique_requests_delivered || 0);
      detailedSummary.responseRate = (this.engagementService.getResponsePercentage(data.current).toFixed(1) || 0);

      this.aggregateTrendsDetails[0].field_value += detailedSummary.number_of_requests;
      this.aggregateTrendsDetails[1].field_value += detailedSummary.delivered;
      this.aggregateTrendsDetails[2].field_value += detailedSummary.responded;
      this.aggregateTrendsDetails[3].field_value = detailedSummary.responseRate;

      if (this.isDeviationEnabled && data.previous) {
        const previous = data.previous;
        const prevRate = this.engagementService.getResponsePercentage(previous);
        const previousRecords = this.engagementService.getRequestRecieved(previous);
        this.aggregateTrendsDetails[0].deviation = Helpers.getFieldDeviation(detailedSummary.number_of_requests, previousRecords);
        this.aggregateTrendsDetails[1].deviation = Helpers.getFieldDeviation(detailedSummary.delivered, previous.number_of_unique_requests_delivered);
        this.aggregateTrendsDetails[2].deviation = Helpers.getFieldDeviation(detailedSummary.responded, previous.number_of_request_generated_rated);
        this.aggregateTrendsDetails[3].deviation = Helpers.getFieldDeviation(detailedSummary.responseRate, prevRate);
      } else {
        this.aggregateTrendsDetails.forEach((item: any) => item.deviation = null);
      }
      this.isDataAvailable = true;
    } else if (data && data.current && this.isDeviationEnabled && data.previous) {
      const detailedSummary = {
        responded: 0,
        delivered: 0,
        number_of_requests: 0,
        responseRate: (this.engagementService.getResponsePercentage(data.current).toFixed(1) || 0),
      };
      const previous = data.previous;
      const prevRate = this.engagementService.getResponsePercentage(previous);
      const previousRecords = this.engagementService.getRequestRecieved(previous);
      this.aggregateTrendsDetails[0].deviation = Helpers.getFieldDeviation(detailedSummary.number_of_requests, previousRecords);
      this.aggregateTrendsDetails[1].deviation = Helpers.getFieldDeviation(detailedSummary.delivered, previous.number_of_unique_requests_delivered);
      this.aggregateTrendsDetails[2].deviation = Helpers.getFieldDeviation(detailedSummary.responded, previous.number_of_request_generated_rated);
      this.aggregateTrendsDetails[3].deviation = Helpers.getFieldDeviation(detailedSummary.responseRate, prevRate);
      this.isDataAvailable = true;
    }
  }
}
